import { useState } from "react"
import { Button, CustomContainer, FlexRow, ScreenTitle } from "src/style"
import BackIcon from 'src/assets/svg/back-icon-d2'
import { RiCloseFill } from "react-icons/ri"

export const CenterPopupHeaderD2: React.FC<any> = ({title, back, close}) => {
    const [isHover, setIsHover] = useState({close: false, back: false})

    return (
        <CustomContainer bottomPadding='1'>
            <FlexRow justifyContent="space-between" gap="2" bottomMargin="0.5">
                <BackIcon 
                    isHover={isHover.back} 
                    onMouseEnter={() => setIsHover({...isHover, back: true})}
                    onMouseLeave={() => setIsHover({...isHover, back: false})}
                    onClick={back}
                    className='icon-component'
                    style={{visibility: back != undefined ? 'visible' : 'hidden'}}
                />
                <Button 
                    titleSize="2" fontWeight="500"
                    width='3.4' shadow='none'
                    height='3.4'
                    radius='0.6'
                    bgColor='#ffffff'
                    hoverBgColor='#FEF3F2'
                    borderColor='none'
                    color='#000000'
                    hoverColor='#B42318'
                    onClick={close}
                >
                    <RiCloseFill style={{fontSize: '2.3rem'}} />
                </Button>
            </FlexRow>
            <ScreenTitle textSize="2" fontWeight="600" color="#211121" align="center">{title}</ScreenTitle>
        </CustomContainer>
    )
}